import Select from 'react-select';

const ReactSelect = ({options,label,name,formik,isMulti = false,disabled = false,required = false,value = null,isDisabled = false}) => {
    return (
        <div className="form-group">
            <label>{label}</label>
            <Select name={name} isMulti={isMulti} noOptionsMessage={e => 'یافت نشد'} className={required && (!formik.values[name] || formik.values[name] == 0) ? 'is-invalid' : ''} onChange={e => formik.setFieldValue(name,isMulti ? e : e.value)} placeholder="انتخاب کنید" required={required} options={options} disabled={disabled} value={value} isDisabled={isDisabled} />
            {formik.errors[name] && formik.touched[name] && (
                <small className="text-danger">{formik.errors[name]}</small>
            )}
        </div>
    );
}

export default ReactSelect;